module.exports = __webpack_public_path__ + "img/skinbox-black.411547ce.png";